import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import store from "@/store/index";
import usePagination from "@/views/components/pagination/usePagination";
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api";
import { tryOnUnmounted } from "@vueuse/core";
import useFilterHeaderTable from "../../filter-header-table/useFilterHeaderTable";

export default function useDynamicTable(props) {
  const keyChange = ref(0);
  const isFilterReset = ref(false);
  const loading = reactive({
    tableField: false,
    tableData: false,
  });

  const dynamicTable = reactive({
    column: [],
    payload: [],
    filterColumn: [],
    filter: [],
    isCreate: false,
  });

  const displayColumnOptions = reactive({
    options: null,
  });

  const { openDefaultErrorModal, openWarningModal } = useValidationModal();

  const {
    pagination,
    paginationInfo,
    onFilterEntity,
    onPageChange,
  } = usePagination();

  const {
    entities,
    filters,
    ordering,
    searchValue,
    contentFilter,
    onSelectEntities,
    onSearch: onSearchVal,
    sortingChanged,
    onSelectFilter,
    onFilter,
  } = useFilterHeaderTable();

  const {
    fetchQueryDisplayModel,
    fetchQueryDataModel,
    editDisplayModel,
    editDisplayTableColumnModel,
    fetchQueryDisplayReportModel,
  } = dynamicTableModel();

  const onSearch = () => {
    onSearchVal("query");
  };

  const isVerified = ref(false);

  const fetchQueryDisplayList = (fetchDataList = true) => {
    if (fetchDataList) {
      loading.tableField = true;
    }

    fetchQueryDisplayModel.payload.DisplayId = props.displayId;
    fetchQueryDisplayModel.payload.Display_Key = props.displayKey;

    store
      .dispatch("api/apiRequest", fetchQueryDisplayModel)
      .then((response) => {
        displayColumnOptions.options = response.data.dynamic_fields;
        dynamicTable.column = orderBySequenceTable(
          selectDisplayTable(response.data.dynamic_fields)
        );
        
        initFilterFields(dynamicTable.column);
        loading.tableField = false;

        if (fetchDataList) {
          keyChange.value++;
          fetchQueryDataList();
        }
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      });
  };

  const fetchQueryDataList = () => {
    loading.tableData = true;
    fetchQueryDataModel.payload.Page = pagination.currentPage;
    fetchQueryDataModel.payload.Limit = entities.value || pagination.perPage;
    fetchQueryDataModel.payload.Ordering = ordering.value;
    fetchQueryDataModel.payload.Filters = filters.value;
    fetchQueryDataModel.payload.DisplayId = props.displayId;
    fetchQueryDataModel.payload.Display_Key = props.displayKey;
    fetchQueryDataModel.payload.QueryDataId = props.queryId;
    fetchQueryDataModel.payload.QueryData_Key = props.queryDataKey;
    fetchQueryDataModel.payload.IsVerified = isVerified.value;

    store
      .dispatch("api/apiRequest", fetchQueryDataModel)
      .then((response) => {
        dynamicTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const selectDisplayTable = (fields) =>
    fields.filter((o) => o.is_display == true);

  const orderBySequenceTable = (fields) =>
    fields.sort((firstItem, secondItem) => firstItem.seq - secondItem.seq);

  const initFilterFields = (fields) => {
    dynamicTable.filterColumn = fields.filter(
      (field) => field.is_filter == true
    );
  };

  const renderCell = (key) => `cell(${key})`;

  const renderHead = (key) => `head(${key})`;

  const editDisplayList = (selectedColumns) => {
    const displayList = [];

    displayColumnOptions.options.map((columnOption) => {
      const displayColumn = selectedColumns.find(
        (columnKey) => columnOption.key == columnKey
      );

      if (displayColumn) {
        return displayList.push({ Key: displayColumn, Value: true });
      }

      contentFilter.filterColumns = contentFilter.filterColumns.filter(
        (column) => column.key !== columnOption.key
      );

      displayList.push({ Key: columnOption.key, Value: false });

      if (columnOption.is_filter) {
        isFilterReset.value = true;
      }
    });

    editDisplayModel.payload.DispalyConfigs = displayList;
    editDisplayModel.payload.Display_Key = props.displayKey;
    editDisplayModel.payload.DisplayId = props.displayId;

    store
      .dispatch("api/apiRequest", editDisplayModel)
      .then((response) => {
        if (isFilterReset.value) {
          onFilter();
        }

        fetchQueryDisplayList();
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      });
  };

  const handleRowChange = (e) => {
    // sortableRowOptions.value.disabled = true;
  };

  const handleColChange = (e) => {
    const draggedColumn = dynamicTable.column[e.oldDraggableIndex];
    const movedColumn = dynamicTable.column[e.newDraggableIndex];

    editDisplayTableColumnModel.payload.Key = draggedColumn.key;
    editDisplayTableColumnModel.payload.From_Seq = draggedColumn.seq;
    editDisplayTableColumnModel.payload.To_Seq = movedColumn.seq;
    editDisplayTableColumnModel.payload.action_list = [];
    editDisplayTableColumnModel.payload.Display_Key = "Customer_List";
    sortableColOptions.disabled = true;
    keyChange.value++;

    dynamicTable.column.splice(
      e.newDraggableIndex,
      0,
      dynamicTable.column.splice(e.oldDraggableIndex, 1)[0]
    );

    if (draggedColumn.key == "action") {
      editDisplayTableColumnModel.payload.action_list =
        draggedColumn.column_property.action_list;
    }
    store
      .dispatch("api/apiRequest", editDisplayTableColumnModel)
      .then(() => {
        fetchQueryDisplayList(false);
        sortableColOptions.disabled = false;
        keyChange.value++;
      })
      .catch((err) => {
        // handle error
      });
  };

  const sortableRowOptions = reactive({
    chosenClass: "is-selected",
    ghostClass: "sortable-ghost",
    onEnd: handleRowChange,
    disabled: false,
    animation: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
  });

  const sortableColOptions = reactive({
    chosenClass: "is-selected",
    ghostClass: "sortable-ghost",
    onEnd: handleColChange,
    disabled: false,
    animation: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
  });

  const confirmViewData = () => {
    if (isVerified.value == false) {
      openWarningModal("ยันยืนการดูข้อมูล", `ต้องการยืนยันใช่หรือไม่ ?`, () => {
        isVerified.value = true;
        fetchQueryDataList();
      });
    } else {
      openWarningModal(
        "ยันยืนการซ่อนข้อมูล",
        `ต้องการยืนยันใช่หรือไม่ ?`,
        () => {
          isVerified.value = false;
          fetchQueryDataList();
        }
      );
    }
  };

  onBeforeMount(() => {
    fetchQueryDisplayList();
  });

  watch(
    [entities, filters, ordering],
    () => {
      pagination.currentPage = 1;

      if (!isFilterReset.value) {
        fetchQueryDataList();
      }

      isFilterReset.value = false;
    },
    { deep: true }
  );

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchQueryDataList();
      }
    },
    { deep: true }
  );

  return {
    loading,
    dynamicTable,
    pagination,
    paginationInfo,
    searchValue,
    displayColumnOptions,
    sortableRowOptions,
    sortableColOptions,
    keyChange,
    renderCell,
    renderHead,
    onSelectEntities,
    onSearch,
    sortingChanged,
    editDisplayList,
    onSelectFilter,
    onFilterEntity,
    onPageChange,
    confirmViewData,
    isVerified
  };
}
